import _get from "./get";
import _post from "./post";
import _put from "./put";
import _del from "./del";

export const get = _get;
export const post = _post;
export const put = _put;
export const del = _del;
